module.exports = __webpack_public_path__ + "img/education-mobile.8cc12ff.jpg";